import React, { useEffect, useState, useCallback } from "react";
import appConfig from "app-config";
import { useModal } from "@jutro/components";
import metadataRentedTrailer from "./MLRentedTrailerCamperTablePopup.json5";
import messages from "./MLRentedTrailerCamperTablePopup.messages.js";
import { MetadataContent } from "@jutro/legacy/uiconfig";
import { useTranslator } from "@jutro/locale";

const MLRentedTrailerCamperTablePopup = (props) => {
    const modalApi = useModal();
    const translator = useTranslator();

    const {
        submissionVM,
        isGPA,
        writeValue,
        setComponentValidation,
        showValidationErrors,
        rentedTrailerCamperRows,
        addRentedTrailerCamper,
        onRentedTrailerEdit,
        onRentedTrailerRemove,
        onCancel,
        ...otherOverrides
    } = props;

    const vehicleVM = submissionVM?.lobData?.personalAuto?.coverables?.vehicles || { value: [] }
    const allVehicles = Array.isArray(vehicleVM.value) ? vehicleVM.value : [];
    const [content, setContent] = useState([]);

    const handleEditRentedTrailerCamper = useCallback(({ index }) => {
        const item = rentedTrailerCamperRows?.[index];
        if (!item) return;

        onRentedTrailerEdit(item, onCancel);
    }, [rentedTrailerCamperRows, onRentedTrailerEdit, onCancel]);

    const handleRemoveRentedTrailerCamper = useCallback(({ index }) => {
        const item = rentedTrailerCamperRows?.[index];
        if (!item) return;

        onRentedTrailerRemove(item, onCancel);
    }, [rentedTrailerCamperRows, onRentedTrailerRemove, onCancel]);

    useEffect(() => {
        setContent(Array.isArray(rentedTrailerCamperRows) && rentedTrailerCamperRows.length > 0)
    }, [])

    const hasRows = Array.isArray(rentedTrailerCamperRows) && rentedTrailerCamperRows.length > 0;

    const generateOverrides = () => {
        const overrides = rentedTrailerCamperRows.map((item, index) => {
            return {
                [`yearCell${index}`]: {
                    className: `cell ${_.get(item, 'error', false) ? 'error-help-text font-weight-bold ' : ''}`
                },
                [`yearErrorAlertIcon${index}`]: {
                    visible: _.get(item, 'error', false)
                },
                [`year${index}`]: {
                    content: item.year
                },
                [`make${index}`]: {
                    content: item.make
                },
                [`model${index}`]: {
                    content: item.model
                },
                [`trim${index}`]: {
                    content: item.trim_ML
                },
                [`vin${index}`]: {
                    content: item.vinOrSerial
                },
                [`editActionCell${index}`]: {
                    content: translator(messages.edit),
                    'aria-labelledby': `year${index} make${index} model${index} bodyType${index} trim${index} vin${index}`                },
                [`removeActionCell${index}`]: {
                    content: translator(messages.remove),
                    'aria-labelledby': `year${index} make${index} model${index} bodyType${index} trim${index} vin${index}`                }
            };
        });

        return Object.assign({}, ...overrides);
    };

    const overrides = {
        ...otherOverrides,
        submissionVM,
        content,
        rentedTrailerCamperTable: {
            visible: hasRows
        },
        rentedTrailerCamperIterable: {
            data: rentedTrailerCamperRows
        },
        modalApi,
        isGPA,
        writeValue,
        setComponentValidation,
        showValidationErrors,
        ...generateOverrides()
    };

    const handleAddRentedTrailerCamper = () => {
        if (typeof addRentedTrailerCamper === "function") {
            addRentedTrailerCamper(onCancel)
        }
    }

    const resolvers = {
        resolveCallbackMap: {
            addRentedTrailerCamper: handleAddRentedTrailerCamper,
            onRentedTrailerRemove : handleRemoveRentedTrailerCamper,
            onRentedTrailerEdit: (callbackProps)=>{
                onRentedTrailerEdit(rentedTrailerCamperRows[callbackProps.index],onCancel)
            },
        }
    }

    return (
        <MetadataContent
            uiProps={metadataRentedTrailer.componentContent}
            overrideProps={overrides}
            {...resolvers}
        />
    );
};

export default MLRentedTrailerCamperTablePopup;